<template>
    <input
            class="form-control"
            type="text"
    />
</template>

<script>
    export default {
        props:     {
            mask:        {
                required: true,
                type:     String
            },
            id:          {
                required: false
            },
            value:       {
                required: false
            },
            greedy:      {
                required: false,
                type:     Boolean,
                default:  false
            }
        },
        methods:   {
            getOptions() {
                const self = this;

                let options = {
                    mask:   self.mask,
                    greedy:  self.greedy
                };

                return options;
            },
            init(clear = false) {
                const self = this;

                if (clear === true) {
                    jQuery(self.$el)
                        .empty();
                }

                jQuery(self.$el)
                    .inputmask(self.getOptions())
                    .val(self.value)
                    // emit event on change.
                    .on('change', function () {
                        self.$emit('input', jQuery(this).val());
                    })
                    .trigger('change');
            }
        },
        mounted:   function () {
            const self = this;

            self.init();
        },
        watch:     {
            value:   function (value) {
                const self = this;

                // update value
                jQuery(self.$el)
                    .val(value);

                jQuery(self.$el)
                    .trigger('change');

                self.$emit('select', value);
            },
            id:      function () {
                const self = this;

                self.init(true);
            },
            mask: function (value) {
                const self = this;

                self.init(true);
            },
            greedy: function (value) {
                const self = this;

                self.init(true);
            }
        },
        unmounted: function () {
            jQuery(this.$el)
                .off()
                .inputmask('remove')
        }
    }
</script>